import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { formPrioritiesData } from '../../helpers/formPrioritiesData'

export const getShortPrioritiesInitialData = (
  financialData: IELTFinancialData | null
): string[] | null => {
  if (financialData?.ShortTermPriorities) {
    return formPrioritiesData(financialData.ShortTermPriorities)
  }
  return null
}
